'use strict';

(function () {
  const scrollBtn = document.querySelector('.scroll-top');
  const scrollBtnActive = 'scroll-top-active';

  const callbackBtn = document.querySelector('.callback');
  const callbackBtnActive = 'callback-active';

  const headerAux = document.querySelectorAll('[data-type="header-slide-down"]');
  const headerAuxActive = 'header-aux-active';

  function toggleElement (element, classActive, scrollDistance) {
    window.addEventListener('scroll', function () {
      if (document.documentElement.scrollTop >= scrollDistance) {
        element.classList.add(classActive);
      }
      if (document.documentElement.scrollTop < scrollDistance) {
        element.classList.remove(classActive);
      }
    });
  }

  if (scrollBtn) {
    toggleElement(scrollBtn, scrollBtnActive, 250);
  }
  if (callbackBtn) {
    toggleElement(callbackBtn, callbackBtnActive, 350);
  }

  if (headerAux) {
    headerAux.forEach(function(item) {
      toggleElement(item, headerAuxActive, 250);
    })
  }

  var $root = $('html, body');

  $('a[href^="#"]').click(function() {
    try {
      var href = $.attr(this, 'href');

      $root.animate({
        scrollTop: $(href).offset().top
      }, 500, function () {
        window.location.hash = href;
      });

      return false;
    } catch {}
  });
})();
